export default "__VITE_ASSET__BgQbnB8$__"